export const translations = {
  es: {
    // Navigation
    "nav.dashboard": "Panel",
    "nav.products": "Mercancia",
    "nav.favorites": "Productos",
    "nav.temperature": "Temperatura",
    "nav.refrigerators": "Refrigeradores",
    "nav.cooling": "Cel. Frio",
    "nav.labels": "Etiquetas",
    "nav.suppliers": "Proveedores",
    "nav.closing": "Cierre",
    "nav.purchaseList": "Lista de compras",
    "nav.reports": "Informes",
    "nav.settings": "Ajustes",

    // Labels / DLC
    "labels.title": "Etiquetas DLC",
    "labels.subtitle": "Gestiona e imprime etiquetas de caducidad para produccion de cocina",
    "labels.addTemplate": "Nueva Plantilla",
    "labels.search": "Buscar plantillas...",
    "labels.noTemplates": "Sin plantillas guardadas",
    "labels.noTemplatesHint": "Crea tu primera plantilla de etiqueta para empezar",
    "labels.selectHint": "Selecciona una plantilla para imprimir",
    "labels.allCategories": "Todas las categorias",
    "labels.addTitle": "Nueva Plantilla de Etiqueta",
    "labels.editTitle": "Editar Plantilla",
    "labels.deleteTitle": "Eliminar Plantilla",
    "labels.deleteDesc": "Esta plantilla de etiqueta sera eliminada permanentemente.",
    "labels.duplicateSuccess": "Plantilla duplicada",
    "labels.saving": "Guardando...",
    "labels.productNameLabel": "Nombre del Producto (aparece en mayusculas en la etiqueta)",
    "labels.productNamePlaceholder": "Ej: SAUCE VERTE",
    "labels.dlcDaysLabel": "Dias de validez (DLC auto-calculo)",
    "labels.categoryLabel": "Categoria",
    "labels.categoryPlaceholder": "Ej: Sauce, Plat, Dessert...",
    "labels.notesLabel": "Notas internas",
    "labels.fabricationDate": "Fecha de Fabricacion",
    "labels.expirationDate": "Fecha DLC",
    "labels.preparedBy": "Preparado por",
    "labels.copies": "Copias a imprimir",
    "labels.printBtn": "Imprimir Etiqueta",
    "labels.previewTitle": "Vista Previa (30×50mm)",
    "labels.history": "Historial de Impresion",
    "labels.noHistory": "Sin historial de impresion",
    "labels.quickPrint": "Reimprimir",
    "labels.count": "plantilla(s)",
    "labels.printedAt": "Impreso el",
    "labels.dlcDays": "dias DLC",
    "labels.printSuccess": "Enviado a imprimir",

    // Cooling Cell
    "cooling.title": "Celula de Refrigeracion",
    "cooling.subtitle": "Control de procesos de enfriamiento rapido (abatidor de temperatura)",
    "cooling.addEntry": "Nueva Entrada",
    "cooling.noRecords": "Sin registros de enfriamiento",
    "cooling.noRecordsHint": "Registra los procesos de enfriamiento rapido para control de seguridad alimentaria",
    "cooling.product": "Producto",
    "cooling.date": "Fecha",
    "cooling.entryTemp": "T. Entrada",
    "cooling.entryTime": "H. Entrada",
    "cooling.exitTemp": "T. Salida",
    "cooling.exitTime": "H. Salida",
    "cooling.notes": "Notas",
    "cooling.status": "Estado",
    "cooling.statusComplete": "Completado",
    "cooling.statusIncomplete": "Incompleto",
    "cooling.statusIssue": "Problema",
    "cooling.addTitle": "Nueva Entrada de Enfriamiento",
    "cooling.editTitle": "Editar Entrada",
    "cooling.deleteTitle": "Eliminar Registro",
    "cooling.deleteDesc": "Seguro que deseas eliminar este registro? Esta accion no se puede deshacer.",
    "cooling.productNameLabel": "Nombre del Producto *",
    "cooling.productNamePlaceholder": "Ej: Caldo de Res",
    "cooling.dateLabel": "Fecha *",
    "cooling.entryTempLabel": "Temperatura de Entrada (C) *",
    "cooling.entryTimeLabel": "Hora de Entrada *",
    "cooling.exitTempLabel": "Temperatura de Salida (C)",
    "cooling.exitTimeLabel": "Hora de Salida",
    "cooling.notesLabel": "Notas (Opcional)",
    "cooling.notesPlaceholder": "Observaciones adicionales...",
    "cooling.saving": "Guardando...",
    "cooling.allStatus": "Todos los estados",
    "cooling.actions": "Acciones",
    "cooling.summary.complete": "Completados",
    "cooling.summary.incomplete": "En proceso",
    "cooling.summary.issue": "Con problema",
    "dashboard.coolingTitle": "Celula de Refrigeracion",
    "dashboard.coolingIncomplete": "proceso(s) incompleto(s)",
    "dashboard.viewCooling": "Ver Celula",
    "dashboard.noCoolingIssues": "Sin procesos pendientes",

    // Suppliers
    "nav.suppliers": "Proveedores",
    "suppliers.title": "Proveedores",
    "suppliers.subtitle": "Gestion de proveedores y seguimiento de precios de compra",
    "suppliers.add": "Nuevo Proveedor",
    "suppliers.search": "Buscar proveedores...",
    "suppliers.noSuppliers": "Sin proveedores",
    "suppliers.noSuppliersHint": "Agrega tus primeros proveedores para rastrear compras y precios",
    "suppliers.nameLabel": "Nombre del Proveedor *",
    "suppliers.notesLabel": "Notas / Informacion de contacto",
    "suppliers.notesPlaceholder": "Tel., email, condiciones de pago...",
    "suppliers.editTitle": "Editar Proveedor",
    "suppliers.addTitle": "Nuevo Proveedor",
    "suppliers.deleteTitle": "Eliminar Proveedor",
    "suppliers.deleteDesc": "Esto eliminara el proveedor y todos sus productos registrados. Esta accion no se puede deshacer.",
    "suppliers.saving": "Guardando...",
    "suppliers.selectHint": "Selecciona un proveedor para ver sus productos",
    "suppliers.products.title": "Productos / Historial de Precios",
    "suppliers.products.add": "Registrar Compra",
    "suppliers.products.noProducts": "Sin compras registradas",
    "suppliers.products.noProductsHint": "Registra una compra para empezar el historial de precios",
    "suppliers.products.productName": "Producto",
    "suppliers.products.price": "Precio",
    "suppliers.products.quantity": "Cantidad",
    "suppliers.products.orderDate": "Fecha de Pedido",
    "suppliers.products.notes": "Notas",
    "suppliers.products.history": "Historial de precios",
    "suppliers.products.addTitle": "Registrar Compra",
    "suppliers.products.editTitle": "Editar Compra",
    "suppliers.products.deleteTitle": "Eliminar Compra",
    "suppliers.products.deleteDesc": "Esta entrada de compra sera eliminada.",
    "suppliers.products.productLabel": "Nombre del Producto *",
    "suppliers.products.productPlaceholder": "Ej: Aguacate, Pechuga de Pollo...",
    "suppliers.products.priceLabel": "Precio (EUR)",
    "suppliers.products.quantityLabel": "Cantidad",
    "suppliers.products.quantityPlaceholder": "Ej: 5kg, 3 cajas",
    "suppliers.products.orderDateLabel": "Fecha del Pedido",
    "suppliers.products.notesLabel": "Notas (Opcional)",
    "suppliers.products.notesPlaceholder": "Observaciones...",
    "suppliers.count": "proveedor(es)",
    "suppliers.orderCount": "compra(s)",
    "suppliers.back": "Volver a la lista",

    // Header / Layout
    "header.settings": "Ajustes",
    "header.logout": "Cerrar sesion",

    // Roles
    "role.admin": "Admin",
    "role.user": "Usuario",

    // Login / Landing
    "login.title": "Tracko Memo",
    "login.subtitle": "Sistema de Control de Cocina",
    "login.selectUser": "Selecciona tu perfil para acceder",
    "login.enterPin": "Ingresa tu PIN de 4 digitos",
    "login.welcome": "Bienvenido de nuevo",
    "login.description": "Inicia sesion en tu panel de operaciones.",
    "login.username": "Usuario",
    "login.usernamePlaceholder": "Ingresa tu usuario",
    "login.password": "Contrasena",
    "login.passwordPlaceholder": "Ingresa tu contrasena",
    "login.submit": "Iniciar Sesion",
    "login.loading": "Iniciando sesion...",
    "login.welcomeBack": "Bienvenido de nuevo",
    "login.error.tooMany": "Demasiados intentos. Por favor espera.",
    "login.error.invalid": "Usuario o contrasena incorrectos",
    "login.error.wrongPin": "PIN incorrecto",
    "login.error.failed": "Error al iniciar sesion. Intenta de nuevo.",
    "login.loggedOut": "Sesion cerrada exitosamente",

    // Dashboard
    "dashboard.title": "Panel",
    "dashboard.state_normal": "Operación Normal",
    "dashboard.state_attention": "Atención requerida",
    "dashboard.state_critical": "Acción inmediata",
    "dashboard.state_label": "Estado del Restaurante",
    "dashboard.last_update": "Última actualización",
    "dashboard.summary_title": "Resumen operativo",
    "dashboard.kpi_products_label": "Productos",
    "dashboard.kpi_temps_label": "Temperaturas",
    "dashboard.kpi_temps_ok": "{ok} / {total} Correctas",
    "dashboard.kpi_checklist_label": "Checklist",
    "dashboard.kpi_alerts_label": "Alertas",
    "dashboard.todo_title": "Cosas para hoy",
    "dashboard.todo_all_done": "Todo está bajo control.",
    "dashboard.todo_all_done_hint": "No hay tareas pendientes por ahora.",
    "dashboard.todo_temps": "Registrar temperaturas ({count} pendientes)",
    "dashboard.todo_checklist": "Completar checklist de cierre",
    "dashboard.todo_cooling": "Finalizar proceso de enfriamiento ({count})",
    "dashboard.todo_expiring": "Revisar productos por caducar ({count})",
    "dashboard.todo_expired": "Retirar productos caducados ({count})",
    "dashboard.activity_title": "Actividad reciente",
    "dashboard.activity_empty": "Sin actividad reciente",
    "dashboard.activity_empty_hint": "Cuando hagas registros aparecerán aquí",
    "dashboard.alerts_title": "Alertas activas",
    "dashboard.alerts_empty": "Todo funciona correctamente.",
    "dashboard.alerts_empty_hint": "No hay alertas activas.",
    "dashboard.expiring_title": "Productos próximos a caducar",
    "dashboard.expiring_empty": "Ningún producto por caducar",
    "dashboard.expiring_empty_hint": "Todo tu inventario está vigente.",
    "dashboard.greetingMorning": "Buenos días",
    "dashboard.greetingAfternoon": "Buenas tardes",
    "dashboard.greetingEvening": "Buenas noches",
    "dashboard.stateLabel": "Estado del restaurante",
    "dashboard.stateAllOk": "Todo bajo control",
    "dashboard.stateAttention": "Atención requerida",
    "dashboard.sectionAttention": "Atención requerida",
    "dashboard.sectionActivity": "Actividad reciente",
    "dashboard.sectionExpiring": "Productos por caducar",
    "dashboard.sectionTemps": "Temperaturas",
    "dashboard.sectionFridges": "Refrigeradores",
    "dashboard.sectionChecklist": "Cierre diario",
    "dashboard.sectionNotifications": "Notificaciones",
    "dashboard.noIncidents": "Todo funciona correctamente.",
    "dashboard.noActivity": "Sin actividad reciente",
    "dashboard.kpiCategories": "categorías",
    "dashboard.kpiLogsToday": "registros hoy",
    "dashboard.kpiNormal": "normales",
    "dashboard.kpiNext7d": "Próximos 7 días",
    "dashboard.kpiCompleted": "{pct}% completado",
    "dashboard.kpiCompletedToday": "completado hoy",
    "dashboard.kpiPending": "Pendiente",
    "dashboard.kpiFinishedToday": "finalizado(s) hoy",
    "dashboard.continueChecklist": "Continuar checklist",
    "dashboard.manageChecklist": "Gestionar cierre",
    "dashboard.viewProducts": "Ver todos",
    "dashboard.viewLogs": "Ver registros",
    "dashboard.manageFridges": "Gestionar refrigeradores",
    "dashboard.tempLastReading": "Último registro",
    "dashboard.tempOutOfRangeShort": "fuera de rango",
    "dashboard.temperaturesLive": "en rango",
    "dashboard.actionAdded": "Producto añadido",
    "dashboard.actionTempLogged": "Temperatura registrada",
    "dashboard.actionLabelPrinted": "Etiqueta DLC impresa",
    "dashboard.actionCoolingStarted": "Enfriamiento iniciado",
    "dashboard.actionCoolingFinished": "Enfriamiento finalizado",
    "dashboard.attTempOOR": "fuera de rango",
    "dashboard.attExpires": "Caduca",
    "dashboard.attChecklistPending": "artículos pendientes",
    "dashboard.attCoolingActive": "en proceso",
    "dashboard.notifTemps": "Temperaturas",
    "dashboard.notifProducts": "Productos",
    "dashboard.notifSystem": "Sistema",
    "dashboard.notifNoIssues": "Sin incidencias",
    "dashboard.notifAlerts": "alerta(s)",
    "dashboard.notifExpiringCount": "por caducar",
    "dashboard.subtitle": "Resumen de tu gestion de seguridad alimentaria",
    "dashboard.clearExpired": "Limpiar Caducados",
    "dashboard.addProduct": "Agregar Producto",
    "dashboard.totalProducts": "Total Productos",
    "dashboard.validItems": "Vigentes",
    "dashboard.expiringSoon": "Por Caducar",
    "dashboard.expired": "Caducados",
    "dashboard.closingChecklist": "Lista de Cierre Diario",
    "dashboard.closingPending": "Pendiente",
    "dashboard.closingDescription": "Marca los articulos con stock suficiente. Los no marcados iran a Lista de Compras.",
    "dashboard.purchases": "Compras",
    "dashboard.noClosingItems": "No hay articulos de cierre configurados. Agrega articulos en la pantalla de Cierre.",
    "dashboard.saveChecklist": "Guardar Lista",
    "dashboard.saving": "Guardando...",
    "dashboard.notifications": "Notificaciones",
    "dashboard.noNotifications": "Sin notificaciones nuevas",
    "dashboard.hasNotifications": "Tienes {count} notificacion(es) sin leer",
    "dashboard.temperature": "Temperatura",
    "dashboard.allInRange": "Todo dentro de rango",
    "dashboard.outOfRange": "fuera de rango",
    "dashboard.viewTempLogs": "Ver Registros de Temperatura",
    "dashboard.refrigerators": "Refrigeradores",
    "dashboard.unitsConfigured": "unidades configuradas",
    "dashboard.manageRefrigerators": "Gestionar Refrigeradores",
    "dashboard.expiringSoonTitle": "Por Caducar",
    "dashboard.viewAll": "Ver Todo",
    "dashboard.noExpiring": "Ningun producto por caducar",
    "dashboard.clearAllExpired": "Limpiar Todos los Productos Caducados",
    "dashboard.clearAllExpiredDesc": "Esto eliminara permanentemente {count} producto(s) caducado(s) de tu inventario. Esta accion no se puede deshacer.",
    "dashboard.clearing": "Limpiando...",

    // Products (now "Merchandise" tab)
    "products.title": "Mercancia",
    "products.subtitle": "Gestiona tu inventario de mercancia",
    "products.addProduct": "Agregar Producto",
    "products.search": "Buscar productos...",
    "products.allCategories": "Todas las Categorias",
    "products.allLocations": "Todas las Ubicaciones",
    "products.allStatus": "Todos los Estados",
    "products.valid": "Vigente",
    "products.warning": "Por caducar",
    "products.expired": "Caducado",
    "products.category": "Categoria",
    "products.location": "Ubicacion",
    "products.status": "Estado",
    "products.product": "Producto",
    "products.expiration": "Caducidad",
    "products.actions": "Acciones",
    "products.noProducts": "No se encontraron productos",
    "products.addFirst": "Agrega Tu Primer Producto",
    "products.deleteTitle": "Eliminar Producto",
    "products.deleteDesc": "Estas seguro de que deseas eliminar este producto? Esta accion no se puede deshacer.",

    // Add/Edit Product
    "addProduct.title": "Agregar Producto",
    "addProduct.editTitle": "Editar Producto",
    "addProduct.subtitle": "Registra un nuevo producto con seguimiento de caducidad",
    "addProduct.editSubtitle": "Actualiza la informacion del producto",
    "addProduct.photoTitle": "Foto del Producto",
    "addProduct.photoDesc": "Toma o sube una foto del producto como referencia (opcional)",
    "addProduct.capture": "Capturar",
    "addProduct.photoAttached": "Foto adjunta al registro del producto",
    "addProduct.openCamera": "Abrir Camara",
    "addProduct.uploadImage": "Subir Imagen",
    "addProduct.detailsTitle": "Detalles del Producto",
    "addProduct.name": "Nombre del Producto *",
    "addProduct.namePlaceholder": "Ej: Leche Entera",
    "addProduct.category": "Categoria *",
    "addProduct.selectCategory": "Selecciona categoria",
    "addProduct.storageLocation": "Ubicacion de Almacenamiento *",
    "addProduct.selectLocation": "Selecciona ubicacion",
    "addProduct.expirationDate": "Fecha de Caducidad *",
    "addProduct.openingDate": "Fecha de Apertura (Opcional)",
    "addProduct.selectDate": "Selecciona fecha",
    "addProduct.batchNumber": "Numero de Lote (Opcional)",
    "addProduct.batchPlaceholder": "Ej: LT-2024-001",
    "addProduct.supplier": "Proveedor (Opcional)",
    "addProduct.supplierPlaceholder": "Ej: Granja Local",
    "addProduct.notes": "Notas (Opcional)",
    "addProduct.notesPlaceholder": "Informacion adicional...",
    "addProduct.submit": "Agregar Producto",
    "addProduct.update": "Actualizar Producto",

    // Favorites (now "Products" tab)
    "favorites.title": "Productos",
    "favorites.subtitle": "Guarda productos frecuentes para agregarlos rapidamente",
    "favorites.addFavorite": "Agregar Favorito",
    "favorites.loading": "Cargando favoritos...",
    "favorites.noFavorites": "Aun no hay favoritos guardados",
    "favorites.noFavoritesHint": "Agrega tus productos mas usados aqui para acceso rapido",
    "favorites.addFirst": "Agrega Tu Primer Favorito",
    "favorites.location": "Ubicacion",
    "favorites.supplier": "Proveedor",
    "favorites.quickAdd": "Agregar Rapido a Productos",
    "favorites.addFavoriteTitle": "Agregar Producto Favorito",
    "favorites.productName": "Nombre del Producto *",
    "favorites.addToProducts": "Agregar {name} a Productos",
    "favorites.expirationDate": "Fecha de Caducidad *",
    "favorites.selectExpiration": "Selecciona fecha de caducidad",
    "favorites.addProduct": "Agregar Producto",
    "favorites.adding": "Agregando...",
    "favorites.deleteTitle": "Eliminar Favorito",
    "favorites.deleteDesc": "Estas seguro de que deseas eliminar este favorito? Esto no afectara productos existentes.",

    // Temperature Logs
    "temp.title": "Registros de Temperatura",
    "temp.subtitle": "Monitorea y registra temperaturas de refrigeradores",
    "temp.logTemp": "Registrar Temperatura",
    "temp.refrigerator": "Refrigerador",
    "temp.allRefrigerators": "Todos los refrigeradores",
    "temp.avgTemp": "Temp. Promedio",
    "temp.minTemp": "Temp. Mínima",
    "temp.maxTemp": "Temp. Máxima",
    "temp.minMax": "Min / Max",
    "temp.outOfRange": "Fuera de Rango",
    "temp.chartTitle": "Historial de Temperatura",
    "temp.chartEmpty": "Sin datos suficientes para el gráfico",
    "temp.recentLogs": "Registros Recientes",
    "temp.noLogs": "No hay registros de temperatura",
    "temp.noResults": "Sin resultados para los filtros seleccionados",
    "temp.outOfRangeLabel": "Fuera de rango",
    "temp.inRangeLabel": "Normal",
    "temp.selectRefrigerator": "Selecciona refrigerador",
    "temp.selectTime": "Selecciona hora",
    "temp.morning": "Mañana",
    "temp.afternoon": "Tarde",
    "temp.evening": "Noche",
    "temp.shift": "Turno",
    "temp.shiftAll": "Todos los turnos",
    "temp.period": "Periodo",
    "temp.periodToday": "Hoy",
    "temp.period7d": "7 días",
    "temp.period30d": "30 días",
    "temp.periodAll": "Todo",
    "temp.onlyOOR": "Solo fuera de rango",
    "temp.viewMore": "Ver más",
    "temp.temperature": "Temperatura (°C)",
    "temp.notes": "Notas (Opcional)",
    "temp.logging": "Registrando...",
    "temp.status": "Estado",
    "temp.loadError": "No pudimos cargar los datos de temperatura",

    // Refrigerators
    "fridge.title": "Refrigeradores",
    "fridge.subtitle": "Configura y gestiona tus unidades de refrigeracion",
    "fridge.addFridge": "Agregar Refrigerador",
    "fridge.loading": "Cargando refrigeradores...",
    "fridge.noFridges": "No hay refrigeradores configurados",
    "fridge.addFirst": "Agrega Tu Primer Refrigerador",
    "fridge.minTemp": "Temp Min",
    "fridge.maxTemp": "Temp Max",
    "fridge.editTitle": "Editar Refrigerador",
    "fridge.addTitle": "Agregar Refrigerador",
    "fridge.name": "Nombre *",
    "fridge.namePlaceholder": "Ej: Refrigerador Principal",
    "fridge.location": "Ubicacion *",
    "fridge.locationPlaceholder": "Ej: Area de Cocina",
    "fridge.minTempLabel": "Temperatura Minima (C) *",
    "fridge.maxTempLabel": "Temperatura Maxima (C) *",
    "fridge.update": "Actualizar",
    "fridge.add": "Agregar",
    "fridge.deleteTitle": "Eliminar Refrigerador",
    "fridge.deleteDesc": "Estas seguro de que deseas eliminar este refrigerador? Los registros de temperatura asociados se mantendran.",
    "fridge.statusNormal": "Normal",
    "fridge.statusOOR": "Fuera de rango",
    "fridge.statusNoData": "Sin registros",
    "fridge.lastReading": "Último registro",
    "fridge.noHistory": "No hay registros todavía.",
    "fridge.rangeLabel": "Rango permitido",
    "fridge.loadError": "No pudimos cargar los refrigeradores",

    // Closing Checklist
    "closing.title": "Lista de Cierre",
    "closing.subtitle": "Revisa los articulos clave al final del dia y marca niveles de stock para manana.",
    "closing.sectionsTitle": "Secciones de la Lista",
    "closing.sectionsDesc": "Organiza tus articulos de cierre en grupos logicos.",
    "closing.addSectionPlaceholder": "Agregar nueva seccion (Ej: Tortillas y Pan)",
    "closing.addSection": "Agregar Seccion",
    "closing.noSections": "No hay secciones aun. Crea una para comenzar.",
    "closing.delete": "Eliminar",
    "closing.itemsTitle": "Articulos de la Lista de Cierre",
    "closing.itemsDesc": "Marca 'Stock suficiente para manana' para cada articulo. Los no marcados se agregaran a la Lista de Compras.",
    "closing.addItemPlaceholder": "Agregar nuevo articulo (Ej: Tortillas de maiz)",
    "closing.noSection": "Sin seccion",
    "closing.addItem": "Agregar Articulo",
    "closing.unassigned": "Articulos Sin Asignar",
    "closing.noItems": "No hay articulos aun. Agrega articulos arriba para comenzar.",
    "closing.sufficientStock": "Stock suficiente para manana",
    "closing.remove": "Quitar",

    // Purchase List
    "purchase.title": "Lista de Compras",
    "purchase.subtitle": "Articulos marcados durante el cierre como stock insuficiente para manana.",
    "purchase.pendingTitle": "Compras Pendientes",
    "purchase.pendingDesc": "Marca los articulos como 'Pedido Realizado' una vez que envies tu orden.",
    "purchase.loading": "Cargando lista de compras...",
    "purchase.empty": "No hay compras pendientes. Todo en orden!",
    "purchase.added": "Agregado",
    "purchase.orderPlaced": "Pedido Realizado",

    // Reports
    "reports.title": "Informes",
    "reports.subtitle": "Genera, previsualiza y exporta informes de Tracko Memo para cualquier rango de fechas.",
    "reports.filtersTitle": "Filtros del Informe",
    "reports.filtersDesc": "Selecciona lo que deseas incluir y el periodo de tiempo.",
    "reports.startDate": "Fecha Inicio",
    "reports.endDate": "Fecha Fin",
    "reports.reportType": "Tipo de Informe",
    "reports.selectStartDate": "Selecciona fecha inicio",
    "reports.selectEndDate": "Selecciona fecha fin",
    "reports.selectType": "Selecciona tipo",
    "reports.typeAll": "Todo (Productos + Temp + Enfriamiento)",
    "reports.typeProducts": "Solo Productos",
    "reports.typeTemperature": "Solo Temperatura",
    "reports.typeCooling": "Solo Celula de Frio",
    "reports.coolingTitle": "Registros de Enfriamiento",
    "reports.coolingDesc": "Procesos de enfriamiento entre {start} y {end}.",
    "reports.noCooling": "Sin registros de enfriamiento en este rango.",
    "reports.colProduct": "Producto",
    "reports.colDate": "Fecha",
    "reports.colEntryTemp": "T. Entrada",
    "reports.colEntryTime": "H. Entrada",
    "reports.colExitTemp": "T. Salida",
    "reports.colExitTime": "H. Salida",
    "reports.generate": "Generar / Ver Informe",
    "reports.generating": "Generando...",
    "reports.downloadPdf": "Descargar PDF",
    "reports.preparingPdf": "Preparando PDF...",
    "reports.productsTitle": "Productos",
    "reports.productsDesc": "Productos con fechas de caducidad entre {start} y {end}.",
    "reports.tempLogsTitle": "Registros de Temperatura",
    "reports.tempLogsDesc": "Lecturas de temperatura entre {start} y {end}.",
    "reports.purchaseTitle": "Lista de Compras",
    "reports.purchaseDesc": "Articulos pendientes de listas de cierre recientes.",
    "reports.noProducts": "No se encontraron productos en este rango de fechas.",
    "reports.noTempLogs": "No se encontraron registros de temperatura en este rango.",
    "reports.noPurchase": "No hay articulos de compra pendientes.",
    "reports.colName": "Nombre",
    "reports.colCategory": "Categoria",
    "reports.colLocation": "Ubicacion",
    "reports.colExpiration": "Caducidad",
    "reports.colStatus": "Estado",
    "reports.colDateTime": "Fecha / Hora",
    "reports.colRefrigerator": "Refrigerador",
    "reports.colTemp": "Temp (C)",
    "reports.colInRange": "En Rango",
    "reports.colNotes": "Notas",
    "reports.colItem": "Articulo",
    "reports.colCreated": "Creado",
    "reports.yes": "Si",
    "reports.no": "No",

    // Settings
    "settings.title": "Ajustes",
    "settings.subtitle": "Gestiona tu cuenta y preferencias",
    "settings.profileTitle": "Perfil",
    "settings.profileDesc": "Informacion de tu cuenta",
    "settings.name": "Nombre",
    "settings.email": "Correo/Usuario",
    "settings.role": "Rol",
    "settings.categoriesTitle": "Categorias",
    "settings.categoriesDesc": "Gestiona las categorias de productos",
    "settings.addCategory": "Agregar Categoria",
    "settings.categoryPlaceholder": "Nueva categoria",
    "settings.locationsTitle": "Ubicaciones de Almacenamiento",
    "settings.locationsDesc": "Gestiona las ubicaciones de almacenamiento",
    "settings.addLocation": "Agregar Ubicacion",
    "settings.locationPlaceholder": "Nueva ubicacion",
    "settings.notificationsTitle": "Notificaciones",
    "settings.notificationsDesc": "Configura las alertas de productos",
    "settings.daysBeforeExpiry": "Dias antes de caducidad para alertar",
    "settings.accessRestricted": "Acceso Restringido",
    "settings.accessRestrictedDesc": "Solo los administradores pueden acceder a la configuracion del sistema.",
    "settings.goBack": "Volver al Panel",
    "settings.default": "Predeterminado",
    "settings.reassignTo": "Reasignar a",
    "settings.deleteTitle": "Eliminar",
    "settings.deleteDesc": "Estas seguro? Los productos con este valor seran reasignados.",

    // Common
    "common.cancel": "Cancelar",
    "common.delete": "Eliminar",
    "common.save": "Guardar",
    "common.saving": "Guardando...",
    "common.loading": "Cargando...",
    "common.edit": "Editar",
    "common.add": "Agregar",
    "common.update": "Actualizar",
    "common.yes": "Si",
    "common.no": "No",

    // Status
    "status.valid": "Vigente",
    "status.warning": "Por caducar",
    "status.expired": "Caducado",
  },

  fr: {
    // Navigation
    "nav.dashboard": "Tableau de bord",
    "nav.products": "Marchandise",
    "nav.favorites": "Produits",
    "nav.temperature": "Temperature",
    "nav.refrigerators": "Refrigerateurs",
    "nav.cooling": "Cel. Refroid.",
    "nav.labels": "Etiquettes",
    "nav.suppliers": "Fournisseurs",
    "nav.closing": "Cloture",
    "nav.purchaseList": "Liste d'achats",
    "nav.reports": "Rapports",
    "nav.settings": "Parametres",

    // Labels / DLC
    "labels.title": "Etiquettes DLC",
    "labels.subtitle": "Gerez et imprimez les etiquettes de peremption pour la production cuisine",
    "labels.addTemplate": "Nouveau Modele",
    "labels.search": "Rechercher des modeles...",
    "labels.noTemplates": "Aucun modele enregistre",
    "labels.noTemplatesHint": "Creez votre premier modele d'etiquette pour commencer",
    "labels.selectHint": "Selectionnez un modele pour imprimer",
    "labels.allCategories": "Toutes les categories",
    "labels.addTitle": "Nouveau Modele d'Etiquette",
    "labels.editTitle": "Modifier le Modele",
    "labels.deleteTitle": "Supprimer le Modele",
    "labels.deleteDesc": "Ce modele d'etiquette sera supprime definitivement.",
    "labels.duplicateSuccess": "Modele duplique",
    "labels.saving": "Enregistrement...",
    "labels.productNameLabel": "Nom du Produit (apparait en majuscules sur l'etiquette)",
    "labels.productNamePlaceholder": "Ex: SAUCE VERTE",
    "labels.dlcDaysLabel": "Jours de validite (calcul DLC auto)",
    "labels.categoryLabel": "Categorie",
    "labels.categoryPlaceholder": "Ex: Sauce, Plat, Dessert...",
    "labels.notesLabel": "Notes internes",
    "labels.fabricationDate": "Date de Fabrication",
    "labels.expirationDate": "Date DLC",
    "labels.preparedBy": "Prepare par",
    "labels.copies": "Copies a imprimer",
    "labels.printBtn": "Imprimer l'Etiquette",
    "labels.previewTitle": "Apercu (30×50mm)",
    "labels.history": "Historique d'Impression",
    "labels.noHistory": "Aucun historique d'impression",
    "labels.quickPrint": "Reimprimer",
    "labels.count": "modele(s)",
    "labels.printedAt": "Imprime le",
    "labels.dlcDays": "jours DLC",
    "labels.printSuccess": "Envoye a l'impression",

    // Cooling Cell
    "cooling.title": "Cellule de Refroidissement",
    "cooling.subtitle": "Controle des processus de refroidissement rapide (cellule de surgele)",
    "cooling.addEntry": "Nouvelle Entree",
    "cooling.noRecords": "Aucun enregistrement de refroidissement",
    "cooling.noRecordsHint": "Enregistrez les processus de refroidissement rapide pour le controle de securite alimentaire",
    "cooling.product": "Produit",
    "cooling.date": "Date",
    "cooling.entryTemp": "T. Entree",
    "cooling.entryTime": "H. Entree",
    "cooling.exitTemp": "T. Sortie",
    "cooling.exitTime": "H. Sortie",
    "cooling.notes": "Notes",
    "cooling.status": "Etat",
    "cooling.statusComplete": "Complete",
    "cooling.statusIncomplete": "Incomplet",
    "cooling.statusIssue": "Probleme",
    "cooling.addTitle": "Nouvelle Entree de Refroidissement",
    "cooling.editTitle": "Modifier l'Entree",
    "cooling.deleteTitle": "Supprimer l'Enregistrement",
    "cooling.deleteDesc": "Etes-vous sur de vouloir supprimer cet enregistrement ? Cette action est irreversible.",
    "cooling.productNameLabel": "Nom du Produit *",
    "cooling.productNamePlaceholder": "Ex: Bouillon de Boeuf",
    "cooling.dateLabel": "Date *",
    "cooling.entryTempLabel": "Temperature d'Entree (C) *",
    "cooling.entryTimeLabel": "Heure d'Entree *",
    "cooling.exitTempLabel": "Temperature de Sortie (C)",
    "cooling.exitTimeLabel": "Heure de Sortie",
    "cooling.notesLabel": "Notes (Optionnel)",
    "cooling.notesPlaceholder": "Observations supplementaires...",
    "cooling.saving": "Enregistrement...",
    "cooling.allStatus": "Tous les etats",
    "cooling.actions": "Actions",
    "cooling.summary.complete": "Completes",
    "cooling.summary.incomplete": "En cours",
    "cooling.summary.issue": "Avec probleme",
    "dashboard.coolingTitle": "Cellule de Refroidissement",
    "dashboard.coolingIncomplete": "processus incomplet(s)",
    "dashboard.viewCooling": "Voir Cellule",
    "dashboard.noCoolingIssues": "Aucun processus en attente",

    // Suppliers
    "nav.suppliers": "Fournisseurs",
    "suppliers.title": "Fournisseurs",
    "suppliers.subtitle": "Gestion des fournisseurs et suivi des prix d'achat",
    "suppliers.add": "Nouveau Fournisseur",
    "suppliers.search": "Rechercher des fournisseurs...",
    "suppliers.noSuppliers": "Aucun fournisseur",
    "suppliers.noSuppliersHint": "Ajoutez vos premiers fournisseurs pour suivre les achats et les prix",
    "suppliers.nameLabel": "Nom du Fournisseur *",
    "suppliers.notesLabel": "Notes / Informations de contact",
    "suppliers.notesPlaceholder": "Tel., email, conditions de paiement...",
    "suppliers.editTitle": "Modifier le Fournisseur",
    "suppliers.addTitle": "Nouveau Fournisseur",
    "suppliers.deleteTitle": "Supprimer le Fournisseur",
    "suppliers.deleteDesc": "Ceci supprimera le fournisseur et tous ses produits enregistres. Cette action est irreversible.",
    "suppliers.saving": "Enregistrement...",
    "suppliers.selectHint": "Selectionnez un fournisseur pour voir ses produits",
    "suppliers.products.title": "Produits / Historique des Prix",
    "suppliers.products.add": "Enregistrer un Achat",
    "suppliers.products.noProducts": "Aucun achat enregistre",
    "suppliers.products.noProductsHint": "Enregistrez un achat pour commencer l'historique des prix",
    "suppliers.products.productName": "Produit",
    "suppliers.products.price": "Prix",
    "suppliers.products.quantity": "Quantite",
    "suppliers.products.orderDate": "Date de Commande",
    "suppliers.products.notes": "Notes",
    "suppliers.products.history": "Historique des prix",
    "suppliers.products.addTitle": "Enregistrer un Achat",
    "suppliers.products.editTitle": "Modifier l'Achat",
    "suppliers.products.deleteTitle": "Supprimer l'Achat",
    "suppliers.products.deleteDesc": "Cette entree d'achat sera supprimee.",
    "suppliers.products.productLabel": "Nom du Produit *",
    "suppliers.products.productPlaceholder": "Ex: Avocat, Blanc de Poulet...",
    "suppliers.products.priceLabel": "Prix (EUR)",
    "suppliers.products.quantityLabel": "Quantite",
    "suppliers.products.quantityPlaceholder": "Ex: 5kg, 3 cartons",
    "suppliers.products.orderDateLabel": "Date de Commande",
    "suppliers.products.notesLabel": "Notes (Optionnel)",
    "suppliers.products.notesPlaceholder": "Observations...",
    "suppliers.count": "fournisseur(s)",
    "suppliers.orderCount": "achat(s)",
    "suppliers.back": "Retour a la liste",

    // Header / Layout
    "header.settings": "Parametres",
    "header.logout": "Deconnexion",

    // Roles
    "role.admin": "Admin",
    "role.user": "Utilisateur",

    // Login / Landing
    "login.title": "Tracko Memo",
    "login.subtitle": "Systeme de Controle de Cuisine",
    "login.selectUser": "Selectionnez votre profil pour acceder",
    "login.enterPin": "Entrez votre PIN a 4 chiffres",
    "login.welcome": "Bon retour",
    "login.description": "Connectez-vous a votre panneau d'operations.",
    "login.username": "Utilisateur",
    "login.usernamePlaceholder": "Entrez votre utilisateur",
    "login.password": "Mot de passe",
    "login.passwordPlaceholder": "Entrez votre mot de passe",
    "login.submit": "Se Connecter",
    "login.loading": "Connexion en cours...",
    "login.welcomeBack": "Bon retour",
    "login.error.tooMany": "Trop de tentatives. Veuillez patienter.",
    "login.error.invalid": "Utilisateur ou mot de passe incorrect",
    "login.error.wrongPin": "PIN incorrect",
    "login.error.failed": "Echec de connexion. Reessayez.",
    "login.loggedOut": "Deconnexion reussie",

    // Dashboard
    "dashboard.title": "Tableau de bord",
    "dashboard.state_normal": "Opération normale",
    "dashboard.state_attention": "Attention requise",
    "dashboard.state_critical": "Action immédiate",
    "dashboard.state_label": "État du restaurant",
    "dashboard.last_update": "Dernière mise à jour",
    "dashboard.summary_title": "Résumé opérationnel",
    "dashboard.kpi_products_label": "Produits",
    "dashboard.kpi_temps_label": "Températures",
    "dashboard.kpi_temps_ok": "{ok} / {total} Correctes",
    "dashboard.kpi_checklist_label": "Clôture",
    "dashboard.kpi_alerts_label": "Alertes",
    "dashboard.todo_title": "À faire aujourd'hui",
    "dashboard.todo_all_done": "Tout est sous contrôle.",
    "dashboard.todo_all_done_hint": "Aucune tâche en attente pour le moment.",
    "dashboard.todo_temps": "Enregistrer températures ({count} en attente)",
    "dashboard.todo_checklist": "Compléter la clôture",
    "dashboard.todo_cooling": "Terminer le refroidissement ({count})",
    "dashboard.todo_expiring": "Vérifier produits à expirer ({count})",
    "dashboard.todo_expired": "Retirer produits expirés ({count})",
    "dashboard.activity_title": "Activité récente",
    "dashboard.activity_empty": "Aucune activité récente",
    "dashboard.activity_empty_hint": "Vos actions apparaîtront ici",
    "dashboard.alerts_title": "Alertes actives",
    "dashboard.alerts_empty": "Tout fonctionne correctement.",
    "dashboard.alerts_empty_hint": "Aucune alerte active.",
    "dashboard.expiring_title": "Produits à expirer",
    "dashboard.expiring_empty": "Aucun produit à expirer",
    "dashboard.expiring_empty_hint": "Tout votre inventaire est valide.",
    "dashboard.greetingMorning": "Bonjour",
    "dashboard.greetingAfternoon": "Bon après-midi",
    "dashboard.greetingEvening": "Bonsoir",
    "dashboard.stateLabel": "État du restaurant",
    "dashboard.stateAllOk": "Tout est sous contrôle",
    "dashboard.stateAttention": "Attention requise",
    "dashboard.sectionAttention": "Attention requise",
    "dashboard.sectionActivity": "Activité récente",
    "dashboard.sectionExpiring": "Produits à expirer",
    "dashboard.sectionTemps": "Températures",
    "dashboard.sectionFridges": "Réfrigérateurs",
    "dashboard.sectionChecklist": "Clôture quotidienne",
    "dashboard.sectionNotifications": "Notifications",
    "dashboard.noIncidents": "Tout fonctionne correctement.",
    "dashboard.noActivity": "Aucune activité récente",
    "dashboard.kpiCategories": "catégories",
    "dashboard.kpiLogsToday": "relevés aujourd'hui",
    "dashboard.kpiNormal": "normaux",
    "dashboard.kpiNext7d": "7 prochains jours",
    "dashboard.kpiCompleted": "{pct}% complété",
    "dashboard.kpiCompletedToday": "complété aujourd'hui",
    "dashboard.kpiPending": "En attente",
    "dashboard.kpiFinishedToday": "terminé(s) aujourd'hui",
    "dashboard.continueChecklist": "Continuer la clôture",
    "dashboard.manageChecklist": "Gérer clôture",
    "dashboard.viewProducts": "Voir tout",
    "dashboard.viewLogs": "Voir relevés",
    "dashboard.manageFridges": "Gérer réfrigérateurs",
    "dashboard.tempLastReading": "Dernier relevé",
    "dashboard.tempOutOfRangeShort": "hors plage",
    "dashboard.temperaturesLive": "dans la plage",
    "dashboard.actionAdded": "Produit ajouté",
    "dashboard.actionTempLogged": "Température enregistrée",
    "dashboard.actionLabelPrinted": "Étiquette DLC imprimée",
    "dashboard.actionCoolingStarted": "Refroidissement démarré",
    "dashboard.actionCoolingFinished": "Refroidissement terminé",
    "dashboard.attTempOOR": "hors plage",
    "dashboard.attExpires": "Expire",
    "dashboard.attChecklistPending": "articles en attente",
    "dashboard.attCoolingActive": "en cours",
    "dashboard.notifTemps": "Températures",
    "dashboard.notifProducts": "Produits",
    "dashboard.notifSystem": "Système",
    "dashboard.notifNoIssues": "Aucun incident",
    "dashboard.notifAlerts": "alerte(s)",
    "dashboard.notifExpiringCount": "à expirer",
    "dashboard.subtitle": "Apercu de votre gestion de securite alimentaire",
    "dashboard.clearExpired": "Nettoyer Expires",
    "dashboard.addProduct": "Ajouter Produit",
    "dashboard.totalProducts": "Total Produits",
    "dashboard.validItems": "Valides",
    "dashboard.expiringSoon": "Bientot Expires",
    "dashboard.expired": "Expires",
    "dashboard.closingChecklist": "Liste de Cloture Quotidienne",
    "dashboard.closingPending": "En attente",
    "dashboard.closingDescription": "Cochez les articles avec un stock suffisant. Les non coches iront dans la Liste d'achats.",
    "dashboard.purchases": "Achats",
    "dashboard.noClosingItems": "Aucun article de cloture configure. Ajoutez des articles dans l'ecran de Cloture.",
    "dashboard.saveChecklist": "Enregistrer la Liste",
    "dashboard.saving": "Enregistrement...",
    "dashboard.notifications": "Notifications",
    "dashboard.noNotifications": "Pas de nouvelles notifications",
    "dashboard.hasNotifications": "Vous avez {count} notification(s) non lue(s)",
    "dashboard.temperature": "Temperature",
    "dashboard.allInRange": "Tout dans la plage",
    "dashboard.outOfRange": "hors plage",
    "dashboard.viewTempLogs": "Voir les Registres de Temperature",
    "dashboard.refrigerators": "Refrigerateurs",
    "dashboard.unitsConfigured": "unites configurees",
    "dashboard.manageRefrigerators": "Gerer les Refrigerateurs",
    "dashboard.expiringSoonTitle": "Bientot Expires",
    "dashboard.viewAll": "Voir Tout",
    "dashboard.noExpiring": "Aucun produit bientot expire",
    "dashboard.clearAllExpired": "Nettoyer Tous les Produits Expires",
    "dashboard.clearAllExpiredDesc": "Ceci supprimera definitivement {count} produit(s) expire(s) de votre inventaire. Cette action est irreversible.",
    "dashboard.clearing": "Nettoyage...",

    // Products (now "Merchandise" tab)
    "products.title": "Marchandise",
    "products.subtitle": "Gerez votre inventaire de marchandise",
    "products.addProduct": "Ajouter Produit",
    "products.search": "Rechercher des produits...",
    "products.allCategories": "Toutes les Categories",
    "products.allLocations": "Tous les Emplacements",
    "products.allStatus": "Tous les Etats",
    "products.valid": "Valide",
    "products.warning": "Bientot expire",
    "products.expired": "Expire",
    "products.category": "Categorie",
    "products.location": "Emplacement",
    "products.status": "Etat",
    "products.product": "Produit",
    "products.expiration": "Expiration",
    "products.actions": "Actions",
    "products.noProducts": "Aucun produit trouve",
    "products.addFirst": "Ajoutez Votre Premier Produit",
    "products.deleteTitle": "Supprimer Produit",
    "products.deleteDesc": "Etes-vous sur de vouloir supprimer ce produit ? Cette action est irreversible.",

    // Add/Edit Product
    "addProduct.title": "Ajouter Produit",
    "addProduct.editTitle": "Modifier Produit",
    "addProduct.subtitle": "Enregistrez un nouveau produit avec suivi d'expiration",
    "addProduct.editSubtitle": "Mettre a jour les informations du produit",
    "addProduct.photoTitle": "Photo du Produit",
    "addProduct.photoDesc": "Prenez ou telechargez une photo du produit pour reference (optionnel)",
    "addProduct.capture": "Capturer",
    "addProduct.photoAttached": "Photo jointe a l'enregistrement du produit",
    "addProduct.openCamera": "Ouvrir Camera",
    "addProduct.uploadImage": "Telecharger Image",
    "addProduct.detailsTitle": "Details du Produit",
    "addProduct.name": "Nom du Produit *",
    "addProduct.namePlaceholder": "Ex: Lait Entier",
    "addProduct.category": "Categorie *",
    "addProduct.selectCategory": "Selectionner categorie",
    "addProduct.storageLocation": "Emplacement de Stockage *",
    "addProduct.selectLocation": "Selectionner emplacement",
    "addProduct.expirationDate": "Date d'Expiration *",
    "addProduct.openingDate": "Date d'Ouverture (Optionnel)",
    "addProduct.selectDate": "Selectionner date",
    "addProduct.batchNumber": "Numero de Lot (Optionnel)",
    "addProduct.batchPlaceholder": "Ex: LT-2024-001",
    "addProduct.supplier": "Fournisseur (Optionnel)",
    "addProduct.supplierPlaceholder": "Ex: Ferme Locale",
    "addProduct.notes": "Notes (Optionnel)",
    "addProduct.notesPlaceholder": "Informations supplementaires...",
    "addProduct.submit": "Ajouter Produit",
    "addProduct.update": "Mettre a jour Produit",

    // Favorites (now "Products" tab)
    "favorites.title": "Produits",
    "favorites.subtitle": "Enregistrez les produits frequents pour un ajout rapide",
    "favorites.addFavorite": "Ajouter Favori",
    "favorites.loading": "Chargement des favoris...",
    "favorites.noFavorites": "Aucun favori enregistre",
    "favorites.noFavoritesHint": "Ajoutez vos produits les plus utilises ici pour un acces rapide",
    "favorites.addFirst": "Ajoutez Votre Premier Favori",
    "favorites.location": "Emplacement",
    "favorites.supplier": "Fournisseur",
    "favorites.quickAdd": "Ajout Rapide aux Produits",
    "favorites.addFavoriteTitle": "Ajouter Produit Favori",
    "favorites.productName": "Nom du Produit *",
    "favorites.addToProducts": "Ajouter {name} aux Produits",
    "favorites.expirationDate": "Date d'Expiration *",
    "favorites.selectExpiration": "Selectionner date d'expiration",
    "favorites.addProduct": "Ajouter Produit",
    "favorites.adding": "Ajout en cours...",
    "favorites.deleteTitle": "Supprimer Favori",
    "favorites.deleteDesc": "Etes-vous sur de vouloir supprimer ce favori ? Cela n'affectera pas les produits existants.",

    // Temperature Logs
    "temp.title": "Registres de Temperature",
    "temp.subtitle": "Surveillez et enregistrez les temperatures des refrigerateurs",
    "temp.logTemp": "Enregistrer Temperature",
    "temp.refrigerator": "Refrigerateur",
    "temp.allRefrigerators": "Tous les refrigerateurs",
    "temp.avgTemp": "Temp. Moyenne",
    "temp.minTemp": "Temp. Min.",
    "temp.maxTemp": "Temp. Max.",
    "temp.minMax": "Min / Max",
    "temp.outOfRange": "Hors Plage",
    "temp.chartTitle": "Historique de Temperature",
    "temp.chartEmpty": "Pas assez de données pour le graphique",
    "temp.recentLogs": "Registres Récents",
    "temp.noLogs": "Aucun registre de temperature",
    "temp.noResults": "Aucun résultat pour les filtres sélectionnés",
    "temp.outOfRangeLabel": "Hors plage",
    "temp.inRangeLabel": "Normal",
    "temp.selectRefrigerator": "Selectionner refrigerateur",
    "temp.selectTime": "Selectionner heure",
    "temp.morning": "Matin",
    "temp.afternoon": "Apres-midi",
    "temp.evening": "Soir",
    "temp.shift": "Poste",
    "temp.shiftAll": "Tous les postes",
    "temp.period": "Période",
    "temp.periodToday": "Aujourd'hui",
    "temp.period7d": "7 jours",
    "temp.period30d": "30 jours",
    "temp.periodAll": "Tout",
    "temp.onlyOOR": "Uniquement hors plage",
    "temp.viewMore": "Voir plus",
    "temp.temperature": "Temperature (°C)",
    "temp.notes": "Notes (Optionnel)",
    "temp.logging": "Enregistrement...",
    "temp.status": "État",
    "temp.loadError": "Impossible de charger les données de temperature",

    // Refrigerators
    "fridge.title": "Refrigerateurs",
    "fridge.subtitle": "Configurez et gerez vos unites de refrigeration",
    "fridge.addFridge": "Ajouter Refrigerateur",
    "fridge.loading": "Chargement des refrigerateurs...",
    "fridge.noFridges": "Aucun refrigerateur configure",
    "fridge.addFirst": "Ajoutez Votre Premier Refrigerateur",
    "fridge.minTemp": "Temp Min",
    "fridge.maxTemp": "Temp Max",
    "fridge.editTitle": "Modifier Refrigerateur",
    "fridge.addTitle": "Ajouter Refrigerateur",
    "fridge.name": "Nom *",
    "fridge.namePlaceholder": "Ex: Refrigerateur Principal",
    "fridge.location": "Emplacement *",
    "fridge.locationPlaceholder": "Ex: Zone de Cuisine",
    "fridge.minTempLabel": "Temperature Minimale (C) *",
    "fridge.maxTempLabel": "Temperature Maximale (C) *",
    "fridge.update": "Mettre a jour",
    "fridge.add": "Ajouter",
    "fridge.deleteTitle": "Supprimer Refrigerateur",
    "fridge.deleteDesc": "Etes-vous sur de vouloir supprimer ce refrigerateur ? Les registres de temperature associes seront conserves.",
    "fridge.statusNormal": "Normal",
    "fridge.statusOOR": "Hors plage",
    "fridge.statusNoData": "Sans données",
    "fridge.lastReading": "Dernier relevé",
    "fridge.noHistory": "Aucun relevé pour le moment.",
    "fridge.rangeLabel": "Plage autorisée",
    "fridge.loadError": "Impossible de charger les refrigerateurs",

    // Closing Checklist
    "closing.title": "Liste de Cloture",
    "closing.subtitle": "Verifiez les articles cles en fin de journee et marquez les niveaux de stock pour demain.",
    "closing.sectionsTitle": "Sections de la Liste",
    "closing.sectionsDesc": "Organisez vos articles de cloture en groupes logiques.",
    "closing.addSectionPlaceholder": "Ajouter nouvelle section (Ex: Pains et Tortillas)",
    "closing.addSection": "Ajouter Section",
    "closing.noSections": "Pas encore de sections. Creez-en une pour commencer.",
    "closing.delete": "Supprimer",
    "closing.itemsTitle": "Articles de la Liste de Cloture",
    "closing.itemsDesc": "Cochez 'Stock suffisant pour demain' pour chaque article. Les non coches seront ajoutes a la Liste d'achats.",
    "closing.addItemPlaceholder": "Ajouter nouvel article (Ex: Tortillas de mais)",
    "closing.noSection": "Sans section",
    "closing.addItem": "Ajouter Article",
    "closing.unassigned": "Articles Non Assignes",
    "closing.noItems": "Aucun article pour l'instant. Ajoutez des articles ci-dessus pour commencer.",
    "closing.sufficientStock": "Stock suffisant pour demain",
    "closing.remove": "Retirer",

    // Purchase List
    "purchase.title": "Liste d'Achats",
    "purchase.subtitle": "Articles signales lors de la cloture comme stock insuffisant pour demain.",
    "purchase.pendingTitle": "Achats en Attente",
    "purchase.pendingDesc": "Marquez les articles comme 'Commande Passee' une fois votre commande envoyee.",
    "purchase.loading": "Chargement de la liste d'achats...",
    "purchase.empty": "Pas d'achats en attente. Tout est en ordre !",
    "purchase.added": "Ajoute",
    "purchase.orderPlaced": "Commande Passee",

    // Reports
    "reports.title": "Rapports",
    "reports.subtitle": "Generez, previsualisez et exportez les rapports Tracko Memo pour n'importe quelle periode.",
    "reports.filtersTitle": "Filtres du Rapport",
    "reports.filtersDesc": "Selectionnez ce que vous souhaitez inclure et la periode.",
    "reports.startDate": "Date Debut",
    "reports.endDate": "Date Fin",
    "reports.reportType": "Type de Rapport",
    "reports.selectStartDate": "Selectionner date debut",
    "reports.selectEndDate": "Selectionner date fin",
    "reports.selectType": "Selectionner type",
    "reports.typeAll": "Tout (Produits + Temp + Refroid.)",
    "reports.typeProducts": "Produits uniquement",
    "reports.typeTemperature": "Temperature uniquement",
    "reports.typeCooling": "Refroidissement uniquement",
    "reports.coolingTitle": "Registres de Refroidissement",
    "reports.coolingDesc": "Processus de refroidissement entre {start} et {end}.",
    "reports.noCooling": "Aucun registre de refroidissement dans cette periode.",
    "reports.colProduct": "Produit",
    "reports.colDate": "Date",
    "reports.colEntryTemp": "T. Entree",
    "reports.colEntryTime": "H. Entree",
    "reports.colExitTemp": "T. Sortie",
    "reports.colExitTime": "H. Sortie",
    "reports.generate": "Generer / Voir Rapport",
    "reports.generating": "Generation...",
    "reports.downloadPdf": "Telecharger PDF",
    "reports.preparingPdf": "Preparation PDF...",
    "reports.productsTitle": "Produits",
    "reports.productsDesc": "Produits avec dates d'expiration entre {start} et {end}.",
    "reports.tempLogsTitle": "Registres de Temperature",
    "reports.tempLogsDesc": "Lectures de temperature entre {start} et {end}.",
    "reports.purchaseTitle": "Liste d'Achats",
    "reports.purchaseDesc": "Articles en attente des listes de cloture recentes.",
    "reports.noProducts": "Aucun produit trouve dans cette periode.",
    "reports.noTempLogs": "Aucun registre de temperature trouve dans cette periode.",
    "reports.noPurchase": "Aucun article d'achat en attente.",
    "reports.colName": "Nom",
    "reports.colCategory": "Categorie",
    "reports.colLocation": "Emplacement",
    "reports.colExpiration": "Expiration",
    "reports.colStatus": "Etat",
    "reports.colDateTime": "Date / Heure",
    "reports.colRefrigerator": "Refrigerateur",
    "reports.colTemp": "Temp (C)",
    "reports.colInRange": "Dans Plage",
    "reports.colNotes": "Notes",
    "reports.colItem": "Article",
    "reports.colCreated": "Cree",
    "reports.yes": "Oui",
    "reports.no": "Non",

    // Settings
    "settings.title": "Parametres",
    "settings.subtitle": "Gerez votre compte et vos preferences",
    "settings.profileTitle": "Profil",
    "settings.profileDesc": "Informations de votre compte",
    "settings.name": "Nom",
    "settings.email": "Email/Utilisateur",
    "settings.role": "Role",
    "settings.categoriesTitle": "Categories",
    "settings.categoriesDesc": "Gerez les categories de produits",
    "settings.addCategory": "Ajouter Categorie",
    "settings.categoryPlaceholder": "Nouvelle categorie",
    "settings.locationsTitle": "Emplacements de Stockage",
    "settings.locationsDesc": "Gerez les emplacements de stockage",
    "settings.addLocation": "Ajouter Emplacement",
    "settings.locationPlaceholder": "Nouvel emplacement",
    "settings.notificationsTitle": "Notifications",
    "settings.notificationsDesc": "Configurez les alertes de produits",
    "settings.daysBeforeExpiry": "Jours avant expiration pour alerter",
    "settings.accessRestricted": "Acces Restreint",
    "settings.accessRestrictedDesc": "Seuls les administrateurs peuvent acceder aux parametres du systeme.",
    "settings.goBack": "Retour au Tableau de bord",
    "settings.default": "Par defaut",
    "settings.reassignTo": "Reassigner a",
    "settings.deleteTitle": "Supprimer",
    "settings.deleteDesc": "Etes-vous sur ? Les produits avec cette valeur seront reassignes.",

    // Common
    "common.cancel": "Annuler",
    "common.delete": "Supprimer",
    "common.save": "Enregistrer",
    "common.saving": "Enregistrement...",
    "common.loading": "Chargement...",
    "common.edit": "Modifier",
    "common.add": "Ajouter",
    "common.update": "Mettre a jour",
    "common.yes": "Oui",
    "common.no": "Non",

    // Status
    "status.valid": "Valide",
    "status.warning": "Bientot expire",
    "status.expired": "Expire",
  },
};
